<template>
  <div>
    <div class="klickbox-edit-title">{{ $t('edit.canvas.next_button_text') }}</div>
    <input
      class="btn"
      type="text"
      style="padding-top:25px; margin-top:-20px;"
      @change="stepUpdateNextButtonText({ event: $event, id: step.id })"
      :value="step.next_button_text || $t('general.labels.next')" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'step',
  ],
  methods: mapActions([
    'stepUpdateNextButtonText',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** NextButton.vue?33cab4fa
 **/